import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Tag } from '../../models/tag.model';
import { TagModalComponent } from '../tag-modal/tag-modal.component';
import { HouseFlat } from '../../models/house-flat.model';
import { TagService } from '../../services/tag.service';

@Component({
  selector: 'app-tags-modal',
  templateUrl: './tags-modal.component.html',
  styleUrl: './tags-modal.component.scss'
})
export class TagsModalComponent {

  @Input() neighborhoodId: string = '';
  @Input() houseFlat?: HouseFlat;
  public tags: Tag[] = [];
  public loading: boolean = true;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private tagService: TagService,
  ) {

  }

  ngOnInit() {
    this.getAll();
  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(
    tag: Tag
  ) {
    const flag = confirm(`¿Está seguro que desea borrar el tag con ID ${tag.tagId}?`);

    if (flag) {
      await this.tagService.delete(
        this.neighborhoodId,
        this.houseFlat!,
        tag
      );

      this.getAll();
    }
  }

  /*
   ██████╗ ███████╗████████╗ █████╗ ██╗     ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██║     ██║
  ██║  ███╗█████╗     ██║   ███████║██║     ██║
  ██║   ██║██╔══╝     ██║   ██╔══██║██║     ██║
  ╚██████╔╝███████╗   ██║   ██║  ██║███████╗███████╗
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝

  */
  async getAll() {

    this.loading = true;
    this.tags = await this.tagService.getAll(
      this.neighborhoodId,
      this.houseFlat!
    );
    this.loading = false;

  } 

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  open(
    tag?: Tag
  ) {
    const modalRef = this.modalService.open(
      TagModalComponent
    );

    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.houseFlat = this.houseFlat;
    modalRef.componentInstance.tag = tag;

    modalRef.closed.subscribe(
      async () => {
    
        this.getAll();

      }
    );
  }

}
